/**
 * Extracted from sections/ns-review-carousel.liquid (inline <script> at line 220).
 * Config bridge: window.__nsReviewCarouselSections, keyed by section id. The Liquid the block
 * needed (its section id plus the settings listed in the bridge) is now
 * handed over as data, so the logic can live in a cacheable, deferred
 * asset instead of being parsed and compiled during the HTML parse
 * (INP work on the PDP). Boots once per registered section id.
 */

(function () {
  var cfg = window.__nsReviewCarouselSections = window.__nsReviewCarouselSections || {};
  function boot(nsSectionId, nsSettings) {
            (function () {
              let rcarSwiper = null;

              function initRcarSwiper() {
                const root = document.getElementById(`shopify-section-${nsSectionId}`);
                if (!root) return;

                const swiperEl = root.querySelector('.ns-rcar__swiper');
                if (!swiperEl) return;
                if (typeof Swiper === 'undefined') return;

                if (rcarSwiper) {
                  rcarSwiper.destroy(true, true);
                  rcarSwiper = null;
                }

                const prevEl = root.querySelector('.ns-rcar__prev');
                const nextEl = root.querySelector('.ns-rcar__next');
                const paginationEl = root.querySelector('.ns-rcar__pagination');

                rcarSwiper = new Swiper(swiperEl, {
                  slidesPerView: nsSettings.cardsMobile,
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                  speed: 600,
                  grabCursor: true,
                  loop: false,
                  watchOverflow: true,
                  navigation: prevEl && nextEl ? { nextEl: nextEl, prevEl: prevEl } : false,
                  pagination: paginationEl
                    ? {
                        el: paginationEl,
                        clickable: true,
                        type: 'bullets'
                      }
                    : false,
                  breakpoints: {
                    769: {
                      slidesPerView: nsSettings.cardsDesktop,
                      slidesPerGroup: 1,
                      spaceBetween: 16
                    }
                  }
                });
              }

              function waitForSwiper(callback) {
                if (typeof Swiper !== 'undefined') {
                  callback();
                  return;
                }
                const checkInterval = setInterval(() => {
                  if (typeof Swiper !== 'undefined') {
                    clearInterval(checkInterval);
                    callback();
                  }
                }, 50);
              }

              waitForSwiper(initRcarSwiper);

              if (typeof Shopify !== 'undefined' && Shopify.designMode) {
                document.addEventListener('shopify:section:load', function () {
                  initRcarSwiper();
                });
              }
            })();
        
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
